/**
 * ModeDetector.ts
 * Detects whether the Dungeon Master is running standalone or embedded
 * in poqpoq World (iframe). Parses URL parameters for context.
 */

export interface AppContext {
    mode: 'standalone' | 'embedded'
    instanceId: string | null
    userId: string | null
    worldName: string | null
    dungeonId: string | null
    maxGridSize: number
}

/**
 * Parse URL and window context to determine app mode.
 */
export function detectMode(): AppContext {
    const params = new URLSearchParams(window.location.search)
    const instanceId = params.get('instance')
    const isIframe = window.parent !== window

    return {
        mode: (isIframe && instanceId) ? 'embedded' : 'standalone',
        instanceId,
        userId: params.get('userId'),
        worldName: params.get('name'),
        dungeonId: params.get('dungeon'),
        maxGridSize: parseInt(params.get('maxSize') ?? '') || 256,
    }
}

/**
 * Quick check for embedded mode.
 */
export function isEmbedded(): boolean {
    return window.parent !== window && new URLSearchParams(window.location.search).has('instance')
}
